import React, { PropsWithChildren } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface ContentCardProps {
  title?: string;
  forceBorder?: boolean;
}

const ContentCard: React.FC<PropsWithChildren<ContentCardProps>> = ({
  title,
  forceBorder,
  children,
}) => (
  <Col
    className={cn('w-full rounded-lg p-6', forceBorder && 'border-b border-od-border-secondary')}
  >
    {title && (
      <Text as="h3" className="text-subheader-sm pb-3 text-od-content-primary">
        {title}
      </Text>
    )}
    {children}
  </Col>
);

export { ContentCard };
